import { Route, Routes } from 'react-router-dom';
import { ErrorPage, HomePage, NotFoundPage } from '../../features';
import { CompanyDetailsPage } from '../../features/CompanyDetails/CompanyDetailsPage';
import { ActivationDetailsPage } from '../../features/CompanyLicenses/ActivationDetailsPage';
import { ProtectedAppOutlet } from '../ProtectedPromoOutlet';
import { CompaniesNotFound } from '../../features/CompaniesNotFound';
import { AppNotFoundPage } from '../../features/AppNotFoundPage';

export const AppRoutes = () => {

    return (
        <Routes>
            <Route path="app" element={<ProtectedAppOutlet />}>
                <Route index element={<HomePage />} />
                <Route path="companies/details" element={<CompanyDetailsPage />} />
                <Route path="companies/licenses" element={<ActivationDetailsPage />} />
                <Route path="*" element={<AppNotFoundPage />} />
            </Route>
            <Route path="errors" element={<ErrorPage />} />
            <Route path="errors/404" element={<NotFoundPage />} />
            <Route path="errors/1004" element={<CompaniesNotFound />} />
            <Route path="*" element={<ErrorPage />} />
        </Routes>
    );
};
